import angular from 'angular';
import insuranceNotesTemplateSelector from './insuranceNotesTemplateSelector';
import './style.scss';

export default angular
  .module('insuranceNotesTemplateSelector', [])
  .component('insuranceNotesTemplateSelector', insuranceNotesTemplateSelector)
  .name;
